import React, { useState } from 'react';
import DownloadButton from './DownloadButton';
import * as api from '../../../../../../../../services/apis';
import { downloadPDFInvoice } from '../../../../../../../../helpers/invoiceHelpers';
import { useAuthentication } from '../../../../../../../../hooks/useAuthentication';
import { ENVIRONEMNT } from '../../../../../../../../constants/common';

const DownloadButtonContainer = ({ rowData, ...restProps }) => {
  const [loading, setLoading] = useState(false);
  const { userInfo } = useAuthentication();
  const handleDownload = () => {
    if (userInfo) {
      const uuid = rowData.invoiceUniqueIdentifier;
      setLoading(true);
      api
        .getInvoiceById(uuid, userInfo.tax_number)
        .then((resp) => {
          const currency = ENVIRONEMNT === 'eiv' ? 'OMR' : '';
          downloadPDFInvoice({ data: resp.data, currency, uuid, setLoading });
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  return (
    <DownloadButton
      {...restProps}
      loading={loading}
      onDownload={handleDownload}
    />
  );
};

export default React.memo(DownloadButtonContainer);
